import { create, all } from 'mathjs'
// configure the default type of numbers as BigNumbers
const config = {
    // Default type of number
    // Available options: 'number' (default), 'BigNumber', or 'Fraction'
    number: 'BigNumber',

    // Number of significant digits for BigNumbers
    precision: 20
}
const math = create(all, config)
export default math
export function bignumber(str){    
    if(typeof str === 'string'){
        str = str.trim().replace(',','')
    }
    
    return math.bignumber(str)    
}